import * as React from 'react';
import { Box, Flex } from '../../CommonUI/Layout';
import { Button, Select, Label } from '../../CommonUI';
import { Text } from 'ilenia';
import { PastOrdersPeriod } from '../../Model';
import { postPastOrdersInfo } from '../../Api/ecommscriptClient';

interface InitialSyncProps {
    source: string;
    totalOrders: number | undefined;
    onSync: (period: PastOrdersPeriod) => void;
    onShowTotalOrders: (period: PastOrdersPeriod) => void;
    tierName: string;
    integrationKey: string;
}

interface InitialSyncState {
    period: PastOrdersPeriod;
}

export class InitialSync extends React.Component<InitialSyncProps, InitialSyncState> {
    constructor(props: InitialSyncProps) {
        super(props);
        this.state = { period: PastOrdersPeriod['1 week'] };
        this.onPeriodChange = this.onPeriodChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    public componentDidMount() {
        this.props.onShowTotalOrders(this.state.period);
    }

    public periodTextName(period: PastOrdersPeriod) {
        return Object.keys(PastOrdersPeriod).find((k) => PastOrdersPeriod[k] === period);
    }

    public onPeriodChange(id: string, value: PastOrdersPeriod) {
        const period = PastOrdersPeriod[value];
        this.props.onShowTotalOrders(period);
        this.setState({ period });
    }

    public onClick() {
        const { integrationKey, totalOrders, source } = this.props;

        if (totalOrders !== undefined) {
            const payload = {
                source,
                totalOrders,
            };
            postPastOrdersInfo(integrationKey, JSON.stringify(payload));
        }
        this.props.onSync(this.state.period);
    }

    public render() {
        const { source, totalOrders, tierName } = this.props;
        const { period } = this.state;
        return (
            <Box>
                <Flex alignItems={'left'} flexDirection={'column'}>
                    <Box ml={20} mb={10} >
                        <Label label="pastOrders.pastOrdersTitle" />
                        <Text id="pastOrders.initialPastOrdersSelectDescription" />
                    </Box>
                    <Flex
                        flexDirection={'row'}
                        alignItems={'flex-end'}
                        justifyContent={'flex-start'}
                    >
                        <Select
                            id="position"
                            label="pastOrders.pastOrder"
                            localize={true}
                            value={this.periodTextName(period)}
                            onChangeEvent={this.onPeriodChange}
                            data={Object.keys(PastOrdersPeriod)}
                        />
                        { totalOrders !== undefined ?
                            <Box mb={12}>
                                <span style={{ color: '#00b67a' }}>{totalOrders}</span> <Text id="pastOrders.totalWillBeSynced"/>
                            </Box> : null
                        }
                    </Flex>
                    <Box>
                        <Flex flexDirection={'row'}>
                            <Button
                                width={'unset'}
                                onClick={this.onClick}
                                track={{
                                    placement: 'Bottom left corner',
                                    action: 'Sync past orders clicked',
                                    name: 'sync-past-orders-button',
                                    value: this.periodTextName(period),
                                    source,
                                    tierName,
                                }}
                            >
                                <Text id="pastOrders.syncPastOrders"/>
                            </Button>
                        </Flex>
                    </Box>
                </Flex>
            </Box>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/PastOrders/InitialSync.tsx